<template>
  <div class="pending-replacements-container">
    <div class="pending-replacements-control-section">
      <div class="pr-spacer"></div>
      <div class="pr-top-actions">
        <mds-button v-if="localPolicyOptions.options['submit-to-production']"
          id="submit-to-production" variation="primary"
          :disabled="!enableSubmit"
          @click="openSubmitModal"
        >
          Submit to Production
        </mds-button>
      </div>
    </div>
    <div class="pending-replacements-grid-section">
      <PendingReplacementsGridNew
        @updateSelected="onSelectUpdate"
        @showToolTip="onShowTooltip"
        @hideToolTip="onHideTooltip"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { get } from 'lodash';
import { EventBus } from '@/utils/event-bus';
import PendingReplacementsGridNew from '@/components/organisms/PendingReplacementsGridNew';

export default {
  name: 'pending-replacements-new',
  data() {
    return {
      enableSubmit: false,
      selectedReplacements: [],
    };
  },
  components: {
    PendingReplacementsGridNew,
  },
  computed: {
    ...mapState({
      policies: (state) => state.user.policies,
      selectedTab: (state) => state.pending.tab,
    }),
    currentViewName() {
      return this.selectedClient > 0 ? 'one-client' : 'all-clients';
    },
    localPolicyOptions() {
      // Tabs are applied to both Views
      return get(this.policies, `pending.views.${this.currentViewName}.tabs.${this.selectedTab}`);
    },
  },
  created() {
    EventBus.$emit('search-clear');
  },
  methods: {
    onShowTooltip(event, status, orientation, size) {
      this.$emit('showTooltip', event, status, orientation, size);
    },
    onHideTooltip(event) {
      this.$emit('hideTooltip', event);
    },
    onSelectUpdate(selectedFunds) {
      if (selectedFunds.length > 0) {
        this.selectedReplacements = selectedFunds;
        this.enableSubmit = true;
      } else {
        this.enableSubmit = false;
      }
    },
    openSubmitModal() {
      const replacementData = this.selectedReplacements.map((item) => {
        /* eslint-disable no-param-reassign */
        if (item.menuIds && item.menuIds.length > 0) {
          item.menuIds = item.menuIds.map((menu) => menu.id);
        }
        item.menuIds = item.menuIds?.length > 0 ? item.menuIds : null;
        return item;
      });
      this.$store.dispatch('openModal', {
        title: 'Submit Replacements',
        component: 'submit-replacements-new',
        data: replacementData,
      });
    },
  },
};
</script>
<style lang="scss">
.pending-replacements-container {
  padding: $mds-space-inset-4-x;
  font-family: $mds-font-family-sans-serif;
  font-size: $mds-font-size-m;
  font-weight: $mds-font-weight-thin;
  height: 100%;
  overflow-y: auto;
}
.pending-replacements-control-section {
  display: flex;
  padding-top: $mds-space-three-quarter-x;
  .prgrid-itemcount {
    line-height: 30px;
  }
  .pr-spacer {
    flex-grow: 1;
  }
  .pr-top-actions {
    button {
      margin-left: $mds-space-inset-4-x;
    }
  }
}
.pending-replacements-grid-section {
  margin-top: $mds-space-inset-2-x;
}
</style>
